import { DaySchedule } from "../slices/dealerAccountInfoSlice";
import { useDealerAccountInfo } from "./useDealerAccountInfo";

export const useDealerHours = (): DaySchedule[] => {
  const keys = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"] as const;
  const { dealerHours } = useDealerAccountInfo();
  return keys.map((key) => dealerHours[key]);
};
